export const OrderProcessPhase = {
    /** 초기상태 */
    IDLE: 'IDLE',
    /** 결제 Process 시작 */
    START: 'START',
    /** 결제 승인 요청중 */
    PROCESSING: 'PROCESSING',
    /** 결제 Process 완료 (성공 및 실패 포함) */
    FINISH: 'FINISH',
} as const

export type OrderProcessPhaseType = Constant<typeof OrderProcessPhase>

export const ProcessingStep = {
    /** 프로세스 초기상태 */
    IDLE: 'IDLE',
    /** 결제 준비 */
    PREPARE: 'PREPARE',
    /** 결제 시작 */
    PROCESSING: 'PROCESSING',
    /** VAN 사 인증요청 (카드, 모바일) */
    VAN_CHECK: 'VAN_CHECK',
    /** FDS 인증요청 */
    FDS_CHECK: 'FDS_CHECK',
    /** 결제 승인 요청 */
    APPLYING: 'APPLYING',
    /** 프로세스 완료 (성공, 실패) */
    FINISH: 'FINISH',
} as const

export type ProcessingStepType = Constant<typeof ProcessingStep>
